import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../utils/colors';

const StyledBox = styled(Box)(() => ({
  backgroundColor: '#fff',
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 8,
  margin: '0px 8px',
  padding: '8px 12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 4,
  // Without this, the card is free to be compressed by its sibling
  // (.tabsPanel, flexGrow: 1) whenever the active tab's content wants more
  // room -- it must always keep its own natural height regardless of
  // which tab (Historique/Conformité) is selected below it.
  flexShrink: 0,
  // A flex item's default min-width is `auto` (its content's intrinsic
  // width), not 0 -- without this, long title/subtitle text refuses to
  // shrink below that width and pushes the whole card wider than the
  // panel column instead of truncating.
  minWidth: 0,
  overflow: 'hidden',
  '& > div': {
    minWidth: 0,
    overflow: 'hidden',
  },
  '& .MuiTypography-h3': {
    fontSize: 14,
    lineHeight: '20px',
    color: spaceCadet[600],
    fontWeight: 700,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  '& .MuiTypography-h4': {
    fontSize: 8,
    lineHeight: '16px',
    color: spaceCadet[400],
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '& strong': {
      color: spaceCadet[500],
    },
  },
}));

export default StyledBox;
